// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.
import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';

const requireComponent = require.context(
  // Look for files in the current directory
  '',
  // Do not look in subdirectories
  true,
  // Only include "_base-" prefixed .vue files
  /[\w-]+\.vue$/
);

var camelize = function camelize(str) {
  return str.replace(/\W+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
};

// For each matching file name...
requireComponent.keys().forEach(fileName => {
  // Get the component config
  const componentConfig = requireComponent(fileName);
  // Get the PascalCase version of the component name
  const componentName = `field${camelize(
    upperFirst(
      fileName
        // Remove the "./_" from the beginning
        .replace(/^\.\/_/, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')
        .replace('-', ' ')
    )
  )}`;
  // Globally register the component
  //fieldI4proTextField
  Vue.component(componentName, componentConfig.default || componentConfig);
});
